import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import Swal from 'sweetalert2'; // Asegúrate de importar SweetAlert2
import { Router } from '@angular/router';
import { OndemandSocketService } from 'src/app/services/ondemand-socket.service';

@Component({
  selector: 'app-lobby-ondemand',
  templateUrl: './lobby-ondemand.component.html',
  styleUrls: ['./lobby-ondemand.component.css']
})
export class LobbyOndemandComponent implements OnInit {

  usuario: any = {};
  private intervalId: any;

  salirFilaForm: FormGroup;

  tiempoEspera: any = {};

  cancelReason: any = [];

  totalPacientes: any;
  minutes: any;

  isLoading: boolean = true;
  mensajeTurno: string = '';
  isLoadingExitFila: boolean = false;

  modalActual: string | null = null;

  constructor(
    private scheduleService: ScheduleService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private router: Router,
    private ondemandSocketService: OndemandSocketService,
    
  ) {
    this.salirFilaForm = this.fb.group({
      paciente: [null, Validators.required],
      id_ondemand: [null, Validators.required],
      reason: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.usuario = new EncriptacionService().getUserInfo();

    // console.log('loading start ', this.isLoading);

    if (this.usuario.typ_id == 2) {
      this.postListUsersWaitList();

      this.ondemandSocketService.onDoctorDisponible().subscribe((data) => {
        // console.log('test 1', data);
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorNoDisponible().subscribe((data) => {
        // console.log('test 2', data);
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorFinalizaConsulta().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onActualizaFila().subscribe((data) => {
        // console.log('test 3', data);
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });

      this.setCancelMessages();
      // console.log('loading final', this.isLoading);
    }


  }


  ngOnDestroy(): void {
    if (this.intervalId && this.tiempoEspera.onWaitlist == true) {
      clearInterval(this.intervalId);
    }
  }
  redondearTiempo(tiempo: number): number {
    return Math.min(Math.max(Math.round(tiempo), 5), 61); // mínimo 5, máximo 61
  }
  postListUsersWaitList() {
    this.isLoading = true;
    this.scheduleService.postListUsersWaitList(this.usuario._id, this.usuario.typ_id)
      .then((response: any) => {
        this.tiempoEspera = response;
        // console.log('Respuesta del servicio:', response);
        
        this.cambiarTextos();
        this.setCancelMessages();
        this.isLoading = false;

        this.salirFilaForm.patchValue({
          paciente: this.usuario._id,
          id_ondemand: this.tiempoEspera.consulta.tel_doc_od_id
        });

        this.cdRef.detectChanges();
      })
      .catch((error: any) => {
        console.error('Error al obtener la lista de espera:', error);
      });
  }


  mostrarModal(tipo: string) {
    // Muestra el mensaje de carga
    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                    <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                        Espere por favor...
                    </h1>
                 </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading(); // Muestra el spinner de carga
      }
    });

    // Llamada al servicio para obtener los motivos de cancelación
    this.scheduleService.getListarCancelReason("ONDEMAND")
      .then((response: any) => {
        this.cancelReason = response;
        // console.log(this.cancelReason);

        // Cierra el mensaje de carga y abre el modal
        Swal.close();
        this.modalActual = tipo;
        document.body.classList.add("modal-open"); // Bloquea el scroll
      })
      .catch((error: any) => {
        console.error("Error al obtener los motivos de cancelación:", error);

        // Cierra el mensaje de carga y muestra una alerta de error
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los motivos de cancelación. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  cerrarModal() {
    this.modalActual = null;
    document.body.classList.remove("modal-open"); // Reactiva el scroll
  }
  abrirConfirmacionSinDevolucion() {
    this.modalActual = 'confirmarSinDevolucion';
  }
  
  salirDeFila() {
    const reasonId = this.salirFilaForm.value.reason;
    const pacienteId = this.usuario._id;
    const idOndemand = this.tiempoEspera.consulta.tel_doc_od_id;

    this.isLoadingExitFila = true;
  
    this.scheduleService.postCancelWaitList(pacienteId, idOndemand, reasonId)
      .then(() => {
        this.modalActual = null;
        document.body.classList.remove("modal-open");
        
        this.isLoadingExitFila = false;
  
        Swal.fire({
          allowOutsideClick: false,
          html: `<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> 
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;"> 
                        Has salido de la fila exitosamente.
                    </h1>`,
          showConfirmButton: false,
          timer: 2000
        });
  
        setTimeout(() => {
          Swal.close();
          this.router.navigateByUrl('/dashboard').then(() => {
            window.location.reload();
          });
        }, 2000);
      })
      .catch(error => {
        console.error("Error al cancelar la espera:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo procesar la solicitud. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  reservaHora() {
    var url = "reserva-hora/";
    this.router.navigate([url]);
  }

  cambiarTextos(){

    // console.log('this.tiempoEspera.data', this.tiempoEspera.data);

    if(this.tiempoEspera.consulta.sta_id == 116){
      this.mensajeTurno = "Se te ha asignado un medico. Ingresa a la sala de espera para ser atendido.";
    }else if(this.tiempoEspera.data.tiempoEsperaTotal <= 15 && this.tiempoEspera.consulta.sta_id == 114 || this.tiempoEspera.consulta.sta_id == 120){
      this.mensajeTurno = "¡Buena noticia! Serás atendido en los próximos minutos. Tu consulta está cerca.";
    }else if(this.tiempoEspera.data.tiempoEsperaTotal > 15 && this.tiempoEspera.data.tiempoEsperaTotal <= 45 && this.tiempoEspera.consulta.sta_id == 114){
      this.mensajeTurno = "Nuestros médicos te atenderán en los próximos minutos. Estamos trabajando para brindarte la mejor atención.";
    }else if(this.tiempoEspera.data.tiempoEsperaTotal > 45 && this.tiempoEspera.consulta.sta_id == 114){
      this.mensajeTurno = "Parece que hay una gran cantidad de pacientes en espera. No te preocupes, serás notificado cuando sea tu turno.";
    }
    

    /*
    <p class="mensaje-turno" *ngIf="tiempoEspera.consulta.sta_id == 116">
        Se te ha asignado un medico. Ingresa a la sala de espera para ser atendido.
    </p>
    <p class="mensaje-turno"
        *ngIf="tiempoEspera.data.tiempoEsperaTotal <= 15 && tiempoEspera.consulta.sta_id == 114 || tiempoEspera.consulta.sta_id == 120">
        ¡Buena noticia! Serás atendido en los próximos minutos. Tu consulta está cerca.
    </p>
    <p class="mensaje-turno"
        *ngIf="tiempoEspera.data.tiempoEsperaTotal > 15 && tiempoEspera.data.tiempoEsperaTotal <= 45 && tiempoEspera.consulta.sta_id == 114">
        Nuestros médicos te atenderán en los próximos minutos. Estamos trabajando para brindarte la mejor atención.
    </p>
    <p class="mensaje-turno"
        *ngIf="tiempoEspera.data.tiempoEsperaTotal > 45 && tiempoEspera.consulta.sta_id == 114">
        Parece que hay una gran cantidad de pacientes en espera. No te preocupes, serás notificado cuando sea tu
        turno.
    </p>
    */


  }
    cancelMsg1: string = '';
  cancelMsg2: string = '';
    private setCancelMessages(): void {
    const isSnabb = this.tiempoEspera?.consulta?.is_snabb;
    const canRefunded = this.tiempoEspera?.consulta?.can_refunded;
    // console.log(this.tiempoEspera);
    

    // console.log('RAW is_snabb:', this.tiempoEspera?.consulta?.is_snabb, typeof this.tiempoEspera?.consulta?.is_snabb);

    // DEBUG (borra cuando confirmes)
    // console.log('SNABB:', isSnabb, 'REFUND:', canRefunded, this.data?.consulta);

    if (isSnabb) {
      this.cancelMsg1 = 'Al confirmar la anulación, se perderá la reserva de la hora y se iniciará el proceso de reembolso del pago realizado.';
      this.cancelMsg2 = 'Para más información, revisa el detalle de reembolso disponible en nuestros términos y condiciones.';
      return;
    }

    if (!isSnabb) {
      this.cancelMsg1 = 'Al salir de la fila no se descontará tu consulta del convenio';
      this.cancelMsg2 = '';
      return;
    }

    this.cancelMsg1 = 'Al hacerlo, perderás tu reserva actual y deberás solicitar una nueva hora si deseas reagendar.';
    this.cancelMsg2 = '';
  }
}
